<script setup lang="ts">
import { IconError } from '#shared'

const emit = defineEmits<{ refresh: [] }>()

const onRefresh = () => emit('refresh')
</script>

<template>
  <div :class="$style.root">
    <div :class="$style.top">
      <IconError :class="$style.icon" />
      <div :class="$style.text">Failed to load messages</div>
    </div>
    <button :class="$style.refresh" @click="onRefresh">Refresh</button>
  </div>
</template>

<style lang="scss" module>
@use '#mixins/button' as button;

.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}

.top {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.icon {
  width: 30px;
  height: 30px;
}

.text {
  font-size: 20px;
  font-weight: 500;
  color: #7a7a7a;
}

.refresh {
  @include button.primary;
}
</style>
